/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, type ReactElement, createContext, forwardRef } from 'react';
import { type ContextValue, type SlotProps, TreeItem as TreeItemCore, type TreeItemProps as TreeItemCoreProps, useContextProps } from 'react-aria-components';
import { $ } from '../../tokens.stylex';

interface TreeItemProps<T> extends Omit<TreeItemCoreProps<T>, 'style' | 'className'>, SlotProps {
  style?: stylex.StyleXStyles;
}

const TreeItemContext = createContext<ContextValue<TreeItemProps<object>, HTMLDivElement>>({});

const TreeItem = forwardRef((props: TreeItemProps<object>, ref: ForwardedRef<HTMLDivElement>) => {
  [props, ref] = useContextProps(props, ref, TreeItemContext);

  const { style, children, ...coreProps } = props;

  return (
    <TreeItemCore ref={ref} {...stylex.props(styles.base, style)} {...coreProps}>
      {children}
    </TreeItemCore>
  );
}) as <T>(p: TreeItemProps<T> & { ref?: ForwardedRef<HTMLDivElement> }) => ReactElement;

const styles = stylex.create({
  base: {
    alignItems: 'center',
    alignSelf: 'stretch',
    backgroundColor: {
      default: 'transparent',
      ':is([data-hovered])': $.opacity02,
    },
    borderBottomColor: $.border04,
    borderBottomStyle: 'solid',
    borderBottomWidth: '1px',
    boxSizing: 'border-box',
    cursor: {
      default: 'pointer',
      ':is([data-disabled])': 'not-allowed',
    },
    display: 'flex',
    gap: 12,
    height: 40,
    paddingBlock: 10,
    paddingInline: 8,
  },
});

export { TreeItem, TreeItemContext, type TreeItemProps };
